// ParentComponent.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AdminRegistration from './AdminRegisteration';
import MainAdminPanel from './MainAdminPanel';

const ParentComponent = () => {
    const [admin, setAdmin] = useState(false);

    return (

        <Routes>
            <Route path="/adminLogin" element={<AdminRegistration admin={admin} setAdmin={(value) => setAdmin(value)} />} />
            <Route path="/adminPanel" element={<MainAdminPanel admin={admin} setAdmin={(value) => setAdmin(value)} />} />
            <Route path="*" element={<Navigate to="/adminLogin" />} />
        </Routes>

    );
};

export default ParentComponent;
